import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'react-app-polyfill/stable';
import 'babel-polyfill';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';

import 'popper.js/dist/popper.min.js';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/md-light-indigo/theme.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import 'primereact/resources/themes/mdc-light-indigo/theme.css';

import { BrowserRouter } from 'react-router-dom';
import './index.scss';



 if (process.env.REACT_APP_MODO !== 'development') {
  console.table = () => {};
  console.log = () => {};
} 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <App />
  </BrowserRouter>,

  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister();
